























import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
	name: 'DateInput',

	components: { FlatPickr },

	setup(props) {
		const date = ref(props.value);
		return { date };
	},

	props: {
		label: {
			required: true,
			type: String,
		},
		placeholder: {
			required: false,
			type: String,
		},
		value: {
			required: false,
			type: [Date, String],
		},
		error: {
			default: '',
			required: false,
			type: String,
		},
		disabled: {
			required: false,
			type: Boolean,
		},
		min: {
			default: null,
			required: false,
			type: [String, Date],
		},
		max: {
			default: null,
			required: false,
			type: [String, Date],
		},
		small: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	computed: {
		config() {
			return {
				dateFormat: 'Y-m-d',
				altFormat: 'Y-m-d',
				altInput: true,
				minDate: this.min,
				maxDate: this.max,
				disableMobile: true,
			};
		},
	},

	beforeUpdate() {
		this.date = this.value;
	},

	methods: {
		updateValue() {
			this.$emit('input', this.date);
		},
	},
};
